import * as Yup from 'yup'

const ProductColourSchema = Yup.object().shape({
  label                     : Yup.string().required('Required'),
  hex_code                  : Yup.string().required('Required'),
  product_colour_filter_ids : Yup.string().required('Required')
})

export default ProductColourSchema